export default __webpack_public_path__ + "static/media/dashboardicon.bb64808a.svg";